import { FC } from 'react'

import { useUpdateQueryParams } from '../../../../../../lib/adapters/next-routing-service/useUpdateQueryParam'
import { useStackedColorsAndSizes } from '../../../../../../lib/hooks/useStackedColorsAndSizes'
import { AddToBagContainer } from '../../contexts/AddToBagContainer'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { SizesSection as GenericSizesSection } from '../SizesSection'

export const SizesSection: FC = () => {
  const updateQueryParams = useUpdateQueryParams()
  const { sizes, selectedSize, category, featuredProduct, productGroup } =
    ProductDetailsContainer.useContainer()

  const { isSizeErrored } = AddToBagContainer.useContainer()

  const { waitlistable: isProductWaitlistable } = featuredProduct

  const { sizeChart } = productGroup

  const { useLargeWidthSizeSelectorItems } = useStackedColorsAndSizes(category)

  if (sizes.length === 0) return null
  return (
    <GenericSizesSection
      sizes={sizes}
      sizeChart={sizeChart}
      selectedSize={selectedSize}
      isProductWaitlistable={isProductWaitlistable}
      minWidthStyle={useLargeWidthSizeSelectorItems ? 'lg' : 'md'}
      isInvalid={isSizeErrored}
      onSizeSelect={size => {
        updateQueryParams({
          size: size.shorthand,
        })
      }}
      disableMobileHorizontalSwipe
    />
  )
}
